(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const btns = document.querySelectorAll("#multi-tabs .tabs-buttons button");
  const boxes = document.querySelectorAll("#multi-tabs .tab-box");

  btns.forEach(btn => {
    btn.addEventListener("click", () => {
      const id = btn.getAttribute("data-id");

      btns.forEach(b => b.classList.remove("active"));
      boxes.forEach(b => b.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(id).classList.add("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
